import { createAuthService } from "services/serviceFactory";
import {
    GetUserStationPreferencesResponse,
    UpdateUserStationPreferencesRequest,
} from "./stationPreferencesTypes";

const accountService = createAuthService("account");

export async function getUserStationPreferences(): Promise<GetUserStationPreferencesResponse> {
    const response = await accountService.get<GetUserStationPreferencesResponse>(
        "/account/v1/Account/getUserStationPreferences"
    );
    return response.data;
}

export async function updateUserStationPreferences(
    request: UpdateUserStationPreferencesRequest
): Promise<void> {
    await accountService.put<void>(
        "/account/v1/Account/updateUserStationPreferences",
        request
    );
}
